import { render, staticRenderFns } from "./gun.vue?vue&type=template&id=3c9675c2&scoped=true&"
import script from "./gun.vue?vue&type=script&lang=js&"
export * from "./gun.vue?vue&type=script&lang=js&"
import style0 from "./gun.vue?vue&type=style&index=0&id=3c9675c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9675c2",
  null
  
)

export default component.exports